import React from 'react';
import styled from 'styled-components';

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;
  align-items: flex-end;
`;

const Field = styled.div`
  label {
    display: block;
    font-size: 0.7rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #94a3b8;
    margin-bottom: 0.2rem;
  }
  select {
    min-width: 160px;
    max-width: 280px;
    padding: 0.45rem 0.65rem;
    border: 1px solid ${(p) => (p.$active ? '#043663' : '#cbd5e1')};
    border-radius: 8px;
    font-size: 0.875rem;
    background: #fff;
    font-weight: ${(p) => (p.$active ? 600 : 400)};
  }
`;

/**
 * Season (campaign) → Phase (seasons) filter controls.
 * Pass state from useAdminSeasonPhaseFilter.
 */
export default function AdminSeasonPhaseFilters({
  campaignId = '',
  seasonId = '',
  seasonOptions = [],
  phaseOptions = [],
  onCampaignChange,
  onPhaseChange,
  allowAll = true,
  disabled = false,
  className,
  seasonLabel = 'Season',
  phaseLabel = 'Phase',
  allSeasonsLabel = 'All seasons',
  allPhasesLabel = 'All phases',
  compact = false,
}) {
  const SelectEl = compact ? 'select' : undefined;
  return (
    <Row className={className}>
      <Field $active={!!campaignId}>
        <label htmlFor="admin-filter-season">{seasonLabel}</label>
        <select
          id="admin-filter-season"
          value={campaignId}
          disabled={disabled}
          onChange={(e) => onCampaignChange?.(e.target.value)}
        >
          {allowAll ? <option value="">{allSeasonsLabel}</option> : null}
          {seasonOptions.map((s) => (
            <option key={s.id} value={s.id}>
              {s.title}
            </option>
          ))}
        </select>
      </Field>
      <Field $active={!!seasonId}>
        <label htmlFor="admin-filter-phase">{phaseLabel}</label>
        <select
          id="admin-filter-phase"
          value={seasonId}
          disabled={disabled}
          onChange={(e) => onPhaseChange?.(e.target.value)}
        >
          {allowAll ? <option value="">{allPhasesLabel}</option> : null}
          {phaseOptions.map((p) => (
            <option key={p.id} value={p.id}>
              {p.name || p.id}
              {String(p.status || '').toLowerCase() === 'active'
                ? ' (Live)'
                : String(p.status || '').toLowerCase() === 'completed'
                  ? ' (Completed)'
                  : ''}
            </option>
          ))}
        </select>
      </Field>
      {SelectEl ? null : null}
    </Row>
  );
}
